export default __webpack_public_path__ + "static/media/arrow.8ceccf90.svg";